import React, { useState } from "react";
import axios from "axios"; // Import axios
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { getApiHeader } from 'utlis/commonfunctions';
import ContentPasteIcon from '@mui/icons-material/ContentPaste';
import swal from "sweetalert";
import Loader from "./loader";


const SERVER_URL = process.env.REACT_APP_API_URL;

const VoucherCount = ({mobile, handlePage, choosedplan_id, choosedplan_name, queueLImit, balanceQueueMessage, selectedVoucherCount, confirmData}) => {

    const [voucherCount, setVoucherCount] = useState(null);
    const [loading, setLoading] = useState(false);

    const handleCount = async () => {

        setLoading(true)

        if (!voucherCount) {
            swal("", "Please enter a valid voucher count", "warning");
            setLoading(false);
            return;
        }
        
        if(voucherCount >0 && voucherCount <= queueLImit){

            

            // call api to check count and payment details
            try {
                const headers = await getApiHeader();
                const response = await axios.post(
                    `${SERVER_URL}recharge-voucher-queueing/check-queueing_data`,
                    { mobile_number: mobile, voucher_count:voucherCount, plan_id:choosedplan_id },
                    { headers }
                );

                if (response.status === 200) {

                    if(response?.data?.data?.confirmation){
                        selectedVoucherCount(voucherCount);
                        confirmData(response.data.data.confirmation);
                        handlePage('confirm');
                    }else{
                        swal("", "Something went wrong, Please try again", "warning");
                    }
                    
                    
                }
                setLoading(false);

            } catch (error) {
                if(error.response?.data?.message !== undefined){
                    const message=error.response?.data?.message;
                    swal("", message, "warning");
                }else{
                    swal("", "Something went wrong, Please try again", "warning");
                }
                
                setLoading(false);
            } finally {
                setLoading(false);
            }

        }else{
            swal("", "Please enter a valid voucher count", "warning");
        }
        
        setLoading(false);


    };



    const VoucherCountValidation = (value) => {

 
        if (value.length < 2 && value <= queueLImit && value > 0) {
            setVoucherCount(value);
        }
        else if (value === "") {
            setVoucherCount(value);
        }
            
        
    };


    const backPage = () => {
      handlePage('plan');
    };


    return (
        <>  
            <div className="formbold-main-wrapper add-plan-wrapper">
                    <div className="formbold-form-wrapper add-plan-form pos-rel">

                    <h6>Voucher Count</h6>
                    <hr />


                    {loading === true && (
                        <Loader />
                    )}
                    <br/>

                    {balanceQueueMessage !== null &&(
                        <p>{balanceQueueMessage}</p>
                    )}

                     <div className="formbold-mb-5 formbold-pt-3  col-lg-6 col-md-12 col-sm-12">
                        <label className="formbold-form-label formbold-form-label-2">Enter the number of recharge vouchers to be queued <span className="madate_mark">*</span></label>
                        <div className="input-group">
                            <input type="text" className="formbold-form-input addInput voucherQueeingInput" maxLength="1" variant="outlined" autoComplete="off" placeholder={`Number of recharge vouchers to be queued. (Max. ${queueLImit})`} keyboardType="numeric" value={voucherCount} onChange={(e) => VoucherCountValidation(e.target.value)} 
                                style={{ width: '70%' }} />
                            <div className="input-group-append spc-exitotp-width">
                                <button className="btn btn-send-otp add-mb-otp-btn" type="button" onClick={() => handleCount()} > Continue </button>
                            </div>
                        </div>
                        
                    </div>

                    <p>Selected Plan : {choosedplan_name}</p>
                    
                    <br/>
                    <br/>
                    <br/>
                    <br/>
                    
                    <div className="button-container">
                      <button onClick={backPage}>
                        Back
                      </button>
                    </div>

                </div>
            </div>

        </>
    );
}

export default VoucherCount;
